/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsSignInResponse } from './RevisdomAPIViewModelsSignInResponse';
import {
    RevisdomAPIViewModelsSignInResponseFromJSON,
    RevisdomAPIViewModelsSignInResponseFromJSONTyped,
    RevisdomAPIViewModelsSignInResponseToJSON,
    RevisdomAPIViewModelsSignInResponseToJSONTyped,
} from './RevisdomAPIViewModelsSignInResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1SignInResponse
 */
export interface ApiResponse1SignInResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1SignInResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1SignInResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsSignInResponse}
     * @memberof ApiResponse1SignInResponse
     */
    data?: RevisdomAPIViewModelsSignInResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1SignInResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1SignInResponse interface.
 */
export function instanceOfApiResponse1SignInResponse(value: object): value is ApiResponse1SignInResponse {
    return true;
}

export function ApiResponse1SignInResponseFromJSON(json: any): ApiResponse1SignInResponse {
    return ApiResponse1SignInResponseFromJSONTyped(json, false);
}

export function ApiResponse1SignInResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1SignInResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsSignInResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1SignInResponseToJSON(json: any): ApiResponse1SignInResponse {
    return ApiResponse1SignInResponseToJSONTyped(json, false);
}

export function ApiResponse1SignInResponseToJSONTyped(value?: ApiResponse1SignInResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsSignInResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

